const CollectionFilters = {
	filterData: [],
	debounceTimer: null,

	init(container) {
		if (!container) return;

		this.container = container;
		this.form = container.querySelector('[data-collection-filters]');
		this.grid = container.querySelector('#CollectionProductGrid');

		if (!this.form) return;

		if (this.form.dataset.facetsBound !== 'true') {
			this.form.dataset.facetsBound = 'true';
			this.bindFormEvents();
		}

		this.priceSlider();
		this.updateCollectionMsg(container);

		if (!container.dataset.facetsUiBound) {
			container.dataset.facetsUiBound = 'true';

			container.addEventListener('change', (event) => {
				if (event.target.matches('[data-facets-sort]')) {
					this.form = container.querySelector('[data-collection-filters]');
					this.queueRender();
				}
			});

			container.addEventListener('click', (event) => {
				if (event.target.closest('.collection-facets__tag-clear')) {
					return;
				}

				const currentFilter = event.target.closest('.js-current-filter');
				if (currentFilter) {
					const linkUrl = new URL(currentFilter.href, window.location.origin);
					const norm = (path) => path.replace(/\/+$/, '') || '/';

					if (norm(linkUrl.pathname) !== norm(window.location.pathname)) {
						return;
					}

					event.preventDefault();
					this.renderPage(linkUrl.searchParams.toString());
					return;
				}

				if (event.target.closest('[data-facets-open]')) {
					if (typeof Header !== 'undefined' && Header.prepareSticky) {
						Header.prepareSticky();
					}
					container.classList.add('facets-open');
					document.body.classList.add('collection-facets-open');
					const overlay = container.querySelector('.collection-facets__overlay');
					if (overlay) overlay.removeAttribute('hidden');
					return;
				}

				if (event.target.closest('[data-facets-close]')) {
					container.classList.remove('facets-open');
					document.body.classList.remove('collection-facets-open');
					const overlay = container.querySelector('.collection-facets__overlay');
					if (overlay) overlay.setAttribute('hidden', '');
					return;
				}

				const moreBtn = event.target.closest('[data-facets-more]');
				if (moreBtn) {
					const list = moreBtn.previousElementSibling;
					if (!list) return;
					list.querySelectorAll('.collection-facets__list-item--hidden').forEach((item) => {
						item.classList.remove('collection-facets__list-item--hidden');
					});
					moreBtn.remove();
				}
			});
		}

		if (!this.popstateBound) {
			window.addEventListener('popstate', () => {
				const params = new URLSearchParams(window.location.search).toString();
				this.renderPage(params, false);
			});
			this.popstateBound = true;
		}
	},

	bindFormEvents() {
		this.form.addEventListener('change', (event) => {
			if (event.target.type === 'checkbox') {
				this.queueRender();
			}
		});
	},

	queueRender() {
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => this.renderFromForm(), 250);
	},

	buildSearchParams() {
		const formData = new FormData(this.form);
		const params = new URLSearchParams();
		const priceRange = this.form.querySelector('.js-price-range');
		let priceMaxDefault = null;

		if (priceRange) {
			const rangeMaxEl = priceRange.querySelector('input[type=range]');
			if (rangeMaxEl) priceMaxDefault = parseFloat(rangeMaxEl.max);
		}

		formData.forEach((value, key) => {
			if (value === '') return;

			if (priceMaxDefault !== null && key.includes('filter.v.price')) {
				const num = parseFloat(value);
				if (!Number.isFinite(num)) return;
				if (key.includes('.gte') && num <= 0) return;
				if (key.includes('.lte') && num >= priceMaxDefault) return;
			}

			params.append(key, value);
		});

		return params.toString();
	},

	sanitizeSearchParams(searchParams) {
		if (!searchParams) return '';
		const params = new URLSearchParams(searchParams);
		const cleaned = new URLSearchParams();
		params.forEach((value, key) => {
			if (value !== '') cleaned.append(key, value);
		});
		return cleaned.toString();
	},

	renderFromForm() {
		this.renderPage(this.buildSearchParams());
	},

	updatePriceDisplay(parent, updateText = true) {
		const rangeS = parent.querySelectorAll('input[type=range]');
		const numberS = parent.querySelectorAll('input[type=number]');
		const minDisplay = parent.querySelector('.js-price-min-display');
		const maxDisplay = parent.querySelector('.js-price-max-display');
		if (!rangeS.length || !numberS.length) return;

		const rangeMax = parseFloat(rangeS[0].max) || 1;
		const symbol = parent.dataset.currencySymbol || '';
		const formatValue = (value) => (symbol ? `${symbol} ${value}` : String(value));
		const setPosition = (el, value, edge) => {
			if (!el) return;
			const raw = parseFloat(value);
			const safeValue = Number.isFinite(raw) ? raw : edge === 'max' ? rangeMax : 0;
			const ratio = Math.min(1, Math.max(0, safeValue / rangeMax));
			el.style.left = `${ratio * 100}%`;
			el.style.right = 'auto';

			if (edge === 'min' && ratio <= 0.08) {
				el.style.transform = 'translateX(0)';
			} else if (edge === 'max' && ratio >= 0.92) {
				el.style.transform = 'translateX(-100%)';
			} else {
				el.style.transform = 'translateX(-50%)';
			}
		};

		if (minDisplay) {
			const v = numberS[0].value;
			if (updateText && v !== '') minDisplay.textContent = formatValue(v);
			setPosition(minDisplay, v, 'min');
		}
		if (maxDisplay) {
			const v = numberS[1].value;
			if (updateText && v !== '') maxDisplay.textContent = formatValue(v);
			setPosition(maxDisplay, v, 'max');
		}
	},

	priceSlider() {
		const parents = this.form.querySelectorAll('.js-price-range');
		if (!parents.length) return;

		parents.forEach((parent) => {
			const rangeS = parent.querySelectorAll('input[type=range]');
			const numberS = parent.querySelectorAll('input[type=number]');
			if (!rangeS.length || !numberS.length) return;

			const syncFromRange = () => {
				const slide1 = parseFloat(rangeS[0].value);
				const slide2 = parseFloat(rangeS[1].value);
				numberS[0].value = Math.round(slide1 * 100) / 100;
				numberS[1].value = Math.round(slide2 * 100) / 100;
				this.updatePriceDisplay(parent);
			};

			rangeS.forEach((el) => {
				el.oninput = syncFromRange;
				el.onchange = () => {
					syncFromRange();
					this.queueRender();
				};
			});

			this.updatePriceDisplay(parent, false);
		});
	},

	renderFilters() {
		const container = document.querySelector('[data-section-type="collection"]');
		if (!container) return;

		const form = container.querySelector('[data-collection-filters]');
		if (form) form.dataset.facetsBound = 'false';

		this.init(container);
		WAU.Quickshop.init();
		WAU.ProductGridVideo.init();
	},

	renderSectionFromFetch(url) {
		this.setLoading(true);
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				this.filterData = [...this.filterData, { html: responseText, url }];
				this.renderProductGrid(responseText);
				this.renderFilters();
			})
			.finally(() => this.setLoading(false));
	},

	renderSectionFromCache(filterDataUrl) {
		const match = this.filterData.find(filterDataUrl);
		if (!match) return;
		this.renderProductGrid(match.html);
		this.renderFilters();
	},

	renderPage(searchParams, updateURLHash = true) {
		searchParams = this.sanitizeSearchParams(searchParams);
		const sections = this.getSections();

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			if (this.filterData.some(filterDataUrl)) {
				this.renderSectionFromCache(filterDataUrl);
			} else {
				this.renderSectionFromFetch(url);
			}
		});

		if (updateURLHash) this.updateURLHash(searchParams);
	},

	renderProductGrid(html) {
		const parsed = new DOMParser().parseFromString(html, 'text/html');
		const nextGrid = parsed.getElementById('CollectionProductGrid');
		const currentGrid = document.getElementById('CollectionProductGrid');

		if (!nextGrid || !currentGrid) return;

		currentGrid.innerHTML = nextGrid.innerHTML;
	},

	setLoading(isLoading) {
		const grid = document.getElementById('CollectionProductGrid');
		if (!grid) return;
		grid.classList.toggle('is-loading', isLoading);
		grid.setAttribute('aria-busy', isLoading ? 'true' : 'false');
	},

	updateCollectionMsg(container) {
		const empty = container.getAttribute('data-empty');
		const filterMsg = container.querySelector('.js-coll-empty-filter');
		const regMsg = container.querySelector('.js-coll-empty');

		if (!filterMsg || !regMsg) return;

		if (empty === 'true') {
			filterMsg.style.display = 'none';
			regMsg.style.display = 'block';
		} else {
			filterMsg.style.display = 'block';
			regMsg.style.display = 'none';
		}
	},

	updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			'',
			`${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`
		);
	},

	getSections() {
		const grid = document.getElementById('main-collection-product-grid');
		if (!grid) return [];

		return [
			{
				id: 'main-collection-product-grid',
				section: grid.dataset.id
			}
		];
	}
};

function initCollectionFacets(container) {
	if (container && container.querySelector('[data-collection-filters]')) {
		CollectionFilters.init(container);
	}
}

document.querySelectorAll('[data-section-type="collection"]').forEach(initCollectionFacets);

document.addEventListener('shopify:section:load', (event) => {
	const container = event.target.querySelector('[data-section-type="collection"]');
	initCollectionFacets(container);
});
